import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import VivoAvatar from "@assets/img/avatar.png";
import { useHistory } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  image: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  grid: {
    justifyContent: "center",
    alignItems: "center",
  },
}));

function KnowMoreAboutIt(props) {
  const classes = useStyles();
  const history = useHistory();

  function onCancel() {
    history.push("/login");
  }

  function handleClose() {
    props.onClose();
  }

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth="md"
    >
      <DialogTitle>Saiba mais</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} sm={9}>
            <Typography>
              Saiba mais O Torpedo Empresas é uma ferramenta muito mais fácil e
              confiável para comunicação via SMS entre aplicações e
              dispositivos, com as mensagens sendo enviadas de forma ágil,
              segura e precisa.
            </Typography>
            <ul>
              <li>
                <Typography>
                  Permite a uma empresa efetuar o envio massivo simultâneo de
                  mensagens SMS para celulares Vivo (informações, alertas e
                  comunicados gerais) através de um computador (WEB).
                </Typography>
              </li>
              <li>
                <Typography>
                  As mensagens deverão ter no máximo 160 caracteres, e poderão
                  ter um cabeçalho específico no início da mensagem
                  (sua_empresa). A quantidade de caracteres do cabeçalho será
                  abatida dos 160 disponíveis para a mensagem.
                </Typography>
              </li>
              <li>
                <Typography>
                  O cliente pode optar por utilizar a interface WEB ou Interface
                  Automática via MO (Mobile Originated) ou MT (Mobile
                  Terminated).
                </Typography>
              </li>
              <li>
                <Typography>
                  Disponível para uso avulso ou pacotes mensais de 750 a
                  5.000.000 de mensagens, com preços a partir de R$125,00 por
                  mês.
                </Typography>
              </li>
              <li>
                <Typography>
                  Otimização da comunicação das empresas com seus funcionários,
                  clientes e parceiros.
                </Typography>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.image}>
              <img
                src={VivoAvatar}
                alt="Avatar da Vivo"
                height="170px"
                width="170px"
              />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

KnowMoreAboutIt.propTypes = {
  open: PropTypes.bool.isRequired,
};

KnowMoreAboutIt.defaultProps = {
  open: false,
};

export default KnowMoreAboutIt;
